import { ResourceName } from "@/types";
import { ReimbursementList } from "./ReimbursementList";
import { ReimbursementShow } from "./ReimbursementShow";
import { getResourceIcon } from "@/utils/icons";

const ReimbursementIcon = getResourceIcon(ResourceName.REIMBURSEMENTS);

const resource = {
  list: ReimbursementList,
  show: ReimbursementShow,
  icon: ReimbursementIcon,
  recordRepresentation: (record: any) => `${record.aegle_id}`,
};

export default resource;
